import {
  Select,
  Container,
  Text,
  Box,
  Flex,
  Spacer,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverHeader,
  PopoverBody,
  PopoverCloseButton,
} from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";
import { useEffect } from "react";

const ListBox = (props) => {
  const { label, options, popoverTitle, popoverBody } = props.select;
  const { setListSelection, listSelection } = props;

  useEffect(() => {
    setListSelection(options[0].value);
  }, []);

  const handleChange = (event) => {
    setListSelection(event.target.value);
  };

  return (
    <Container>
      <Box mb="4">
        <Flex>
          <Text fontSize="lg" as="b">
            {label}
          </Text>
          {popoverTitle !== "" && (
            <>
              <Spacer />
              <Popover>
                <PopoverTrigger>
                  <InfoOutlineIcon m="auto" style={{ cursor: "pointer" }} />
                </PopoverTrigger>
                <PopoverContent
                  color="white"
                  bg="blue.800"
                  borderColor="blue.800"
                >
                  <PopoverArrow />
                  <PopoverHeader>{popoverTitle}</PopoverHeader>
                  <PopoverCloseButton />
                  <PopoverBody>
                    <Text>{popoverBody}</Text>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            </>
          )}
        </Flex>
      </Box>
      <Select size="lg" value={listSelection} onChange={handleChange}>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
    </Container>
  );
};

export default ListBox;
